import { render, staticRenderFns } from "./EditPlace.vue?vue&type=template&id=baad9ae2&scoped=true&"
import script from "./EditPlace.vue?vue&type=script&lang=js&"
export * from "./EditPlace.vue?vue&type=script&lang=js&"
import style0 from "./EditPlace.vue?vue&type=style&index=0&id=baad9ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baad9ae2",
  null
  
)

export default component.exports